import { useContext } from "react";
import { Context } from "../../store";
import { toggleLanguages } from "../../store/reducer";
import { useTranslation } from "react-i18next";

import Modal from "./Index";
import { OptionButton } from "./Buttons";
import H2 from "../Typography/Headings";

import { LANGUAGES } from "../VideoPlayer";
import resources from "../../assets/translations/index";

const LanguageModal = () => {
  const { i18n } = useTranslation();
  const [{ player }, dispatch] = useContext(Context);

  const onClick = (key) => () => {
    player.language = key;
    if (Object.keys(resources).includes(key)) {
      i18n.changeLanguage(key);
    }
    dispatch(toggleLanguages());
  };

  return (
    <div className="max-w-3xl w-full md:max-h-96 h-full overflow-y-scroll scroll-bar pb-4">
      <H2 text="Subtitles" />
      <div className="stack chapters px-4">
        {Object.entries(LANGUAGES).map(([key, value]) => (
          <OptionButton
            key={key}
            onClick={onClick(key)}
            text={value}
            withBefore={false}
            className="py-4 px-6"
          />
        ))}
      </div>
    </div>
  );
};

export default Modal(LanguageModal);
